export const TAB_QUERY_CACHE_TIME = 15 * 60 * 1000;
export const RELATED_DATA_POLL_REFETCH_INTERVAL = 5000;
